import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Forces the page to scroll back to the top whenever the route pathname changes.
 *
 * - Skips the scroll if the URL contains a hash anchor (#reviews, #cart, …) so
 *   that anchored navigation (e.g. "voir les avis") still jumps to the section.
 * - Uses `instant` behaviour to avoid jank when switching pages quickly.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // Let the browser handle the in-page anchor
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      // Older browsers don't accept the `behavior` option — fallback
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
